import { Link } from "react-router-dom";
import allBrands from "./img/allBrands.jpg";
import glo from "./img/glo.jpg";
import vuse from "./img/vuse.jpg";
import qr from "./img/qr.png";
import PlaceHolderIcon from "./img/placeholder-card-arrow.svg?react";

import "./style.scss";

const brandImages = {
  glo: glo,
  vuse: vuse,
};

const DARK_BRANDS = new Set(["glo", "vuse"]);

export default function ActivityCardPlaceholder({ brands, variant }) {
  const isQr = variant === "qr";
  let imgSrc = allBrands;
  let isDark = false;

  if (isQr) {
    imgSrc = qr;
    isDark = true;
  } else if (brands?.length === 1 && brandImages[brands[0]]) {
    imgSrc = brandImages[brands[0]];
    isDark = DARK_BRANDS.has(brands[0]);
  } else if (brands?.length === 2) {
    imgSrc = allBrands;
  }

  return (
    <div
      className={`activity-card-placeholder${isDark ? " dark" : ""}${isQr ? " qr" : ""}`}
    >
      <Link to={isQr ? "/qr-scanner-landing" : "/coupons"}>
        <div className="content">
          <div className="img-wrapper">
            <img
              src={imgSrc}
              alt={isQr ? "Vuse Umfrage" : "activity-card-placeholder-image"}
              loading="lazy"
              className="thumb"
            />
          </div>
          <div className="copy-wrapper">
            <div className="copy">
              <span className="click">
                {isQr ? "Immer wieder mehr Punkte" : "Klicken und prüfen"}
              </span>
              <h3 className="text">
                {isQr ? (
                  <>
                    <strong>An Vuse Umfrage</strong>
                    <br />
                    teilnehmen
                  </>
                ) : (
                  <>
                    <strong>Verfügbare</strong>
                    <br />
                    Gutscheine
                  </>
                )}
              </h3>
            </div>
            <PlaceHolderIcon className="placeholder-card-arrow" />
          </div>
        </div>
      </Link>
    </div>
  );
}
